import { Loading } from "../ui";

interface BAASignSectionViewProps {
  isAccepting: boolean;
  hasAgreed: boolean;
  onAgreedChange: (agreed: boolean) => void;
  onAccept: () => void;
}

export const BAASignSectionView = ({
  isAccepting,
  hasAgreed,
  onAgreedChange,
  onAccept,
}: BAASignSectionViewProps) => {
  return (
    <div className="rounded-2xl border border-white/40 bg-card/80 p-8 shadow-[0_8px_40px_rgba(0,0,0,0.08)] backdrop-blur-xl duration-500 animate-in fade-in slide-in-from-bottom-4">
      <div className="space-y-6">
        <label
          htmlFor="baa-agreement"
          className="group flex cursor-pointer items-start rounded-2xl border border-primary-border bg-primary-subtle p-6 transition-all hover:bg-primary-subtle"
        >
          <div className="mt-0.5 flex h-5 items-center">
            <input
              type="checkbox"
              id="baa-agreement"
              checked={hasAgreed}
              onChange={(e) => onAgreedChange(e.target.checked)}
              className="h-5 w-5 cursor-pointer rounded-lg border-input text-primary transition-all focus-visible:shadow-focus group-hover:scale-110"
              disabled={isAccepting}
            />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium leading-snug text-foreground">
              Accept Business Associate Agreement
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              I have read and agree to the terms outlined above.
            </p>
          </div>
        </label>

        <button
          onClick={onAccept}
          disabled={!hasAgreed || isAccepting}
          className={`w-full transform rounded-2xl px-6 py-4 text-lg font-bold transition-all duration-300 active:scale-[0.98] ${
            !hasAgreed || isAccepting
              ? "cursor-not-allowed border border-border bg-surface-sunken text-text-disabled"
              : "bg-primary text-white shadow-sm hover:bg-primary-hover"
          }`}
        >
          {isAccepting ? (
            <span className="flex items-center justify-center">
              <Loading size={24} tone="inverse" fullScreen={false} />
              <span className="ml-3">Processing...</span>
            </span>
          ) : (
            "Accept and Continue"
          )}
        </button>
      </div>
    </div>
  );
};
